import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { Layout } from 'antd';
import ScrollToTopOnMount from '../scroll_to_top_on_mount/ScrollToTopOnMount';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { nullSafeGet } from '../../utils/DataAccessUtils';

const { Content } = Layout;

require('./RequestsForProposalOverviewPage.less');

const RequestsForProposalPage: FC<any> = ({
	history,
	companyConfig,
	childRoutes,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/buyer/sourcing/overview/${key}`),
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{
			key: 'all',
			name: 'All',
		},
	];

	return (
		<div>
			<ScrollToTopOnMount />

			<div>
				<Route
					path="/buyer/requestsForProposal/overview"
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: `/buyer/requestsForProposal/overview/all`,
							}}
						/>
					)}
				/>
				<Content className="requestsForProposalPage" style={{ padding: '0 0.5em' }}>
					<div
						style={{
							margin: '0 -8px',
							padding: '24px',
							paddingBottom: 0,
							background: nullSafeGet('detail.config.theme.navblock', companyConfig),
							marginBottom: 8,
						}}
					>
						<h4
							style={{
								color: 'rgba(255, 255, 255, 0.9)',
								marginRight: 8,
								marginBottom: 24,
							}}
						>
							Requests for Proposal
						</h4>
						<SubnavTabs tabs={tabs} onChange={handleTabChange} isActive={checkTabActive} />
					</div>
					{childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</Content>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config,

	currentUser: state.session.currentUser,
	requestsForProposal: state.requests_for_proposal,
});

export default withRouter<any, any>(connect(mapStateToProps)(RequestsForProposalPage));
